module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-4-b97f9018f4fa235d7c19f39ef3c2ee6a.jpg";